module.exports = "/_next/static/images/owc-ab2359e0b6d3b23a931ec281e3445399.svg";